import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UtilService } from '../../../services/util.service';
import { VisitorTrackerDTO } from '../../../services/api/api';
import { SbDateTime } from '../../../services/api/api-date-time';

export interface TrackerValuesInterface {
  index: number;
  count: number;
  unique: number;
  dwellTime: number;
}

@Component({
  selector: 'sb-comp-tracker-values-element',
  templateUrl: './tracker-values-element.component.html',
  styleUrls: ['./tracker-values-element.component.scss'],
  standalone: false,
})
export class TrackerValuesElementComponent implements OnInit {
  @Input() date: SbDateTime;
  // tslint:disable-next-line:variable-name
  _trackerValueElement: TrackerValuesInterface;
  @Input() set trackerValueElement(val: TrackerValuesInterface) {
    this._trackerValueElement = val;
    this.count = this._trackerValueElement?.count;
    this.unique = this._trackerValueElement?.unique;
    this.dwellTime = this._trackerValueElement?.dwellTime;
  }

  get trackerValueElement(): TrackerValuesInterface {
    return this._trackerValueElement;
  }

  @Input() tracker: VisitorTrackerDTO;
  @Input() editMode: number;
  @Output() valueUpdateEmitter: EventEmitter<TrackerValuesInterface>;

  loading: boolean;

  count: number;
  unique: number;
  dwellTime: number;

  constructor(public util: UtilService) {
    this.valueUpdateEmitter = new EventEmitter<TrackerValuesInterface>();
    this.loading = false;
    this.count = null;
    this.unique = null;
    this.dwellTime = null;
  }

  ngOnInit(): void {
    if (!this.tracker || !this.trackerValueElement) {
      this.loading = true;
    }
  }

  countChange($event) {
    if ($event && $event > 0) {
      if ($event >= 1000000) {
        $event = 1000000; // known bug that displayed value is different from input value (lost binding)
      }
      this.count = $event;
    } else {
      this.count = null;
    }
    this.updateTrackerValues();
  }

  uniqueChange($event: number) {
    if ($event && $event > 0) {
      if ($event >= 1000000) {
        $event = 1000000; // known bug that displayed value is different from input value (lost binding)
      }
      this.unique = +$event;
    } else {
      this.unique = null;
    }
    this.updateTrackerValues();
  }

  dwellTimeChange($event: number) {
    if ($event && $event > 0) {
      if ($event >= 1000000) {
        $event = 1000000; // known bug that displayed value is different from input value (lost binding)
      }
      this.dwellTime = +$event;
    } else {
      this.dwellTime = null;
    }
    this.updateTrackerValues();
  }

  updateTrackerValues() {
    if (this.trackerValueElement) {
      this.trackerValueElement.count = this.count;
      this.trackerValueElement.unique = this.unique;
      this.trackerValueElement.dwellTime = this.dwellTime;
      this.valueUpdateEmitter.emit(this.trackerValueElement);
    }
  }
}
